import React from "react"
import {useTranslation} from "react-i18next"

import {FlyoutDataRow, FlyoutGrid, FlyoutSectionRow} from "../../../components/Flyout"
import {TTabComponentProps} from "./DealDetailFlyout.tsx"

export const ProspectInfo: React.FC<TTabComponentProps> = ({prospect}) => {
  const {t} = useTranslation()

  return (
    <FlyoutGrid>
      <FlyoutSectionRow>{t("SalesAssistant_Deals_Detail_Company")}</FlyoutSectionRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Name")}>{prospect?.name ?? "-"}</FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_CompanyId")}>
        {prospect?.organization_number ?? "-"}
      </FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_City")}>{prospect?.city ?? "-"}</FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Country")}>{prospect?.country?.name ?? "-"}</FlyoutDataRow>
      <FlyoutSectionRow>{t("SalesAssistant_Deals_Detail_MainContact")}</FlyoutSectionRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_FirstName")}>
        {prospect?.contact_person_first_name ?? "-"}
      </FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_LastName")}>
        {prospect?.contact_person_last_name ?? "-"}
      </FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Email")}>{prospect?.email ?? "-"}</FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_PhoneNumber")}>
        {prospect?.phone_number ?? "-"}
      </FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Website")}>{prospect?.website ?? "-"}</FlyoutDataRow>
      <FlyoutSectionRow>{t("SalesAssistant_Deals_Detail_Other")}</FlyoutSectionRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_AdditionalPhoneNumber")}>
        {prospect?.additional_phone_number ?? "-"}
      </FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Note")}>{prospect?.notes ?? "-"}</FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Segment")}>{prospect?.segment ?? "-"}</FlyoutDataRow>
      <FlyoutDataRow legend={t("SalesAssistant_Deals_Detail_Source")}>{prospect?.source ?? "-"}</FlyoutDataRow>
    </FlyoutGrid>
  )
}
